<template>
  <v-tooltip top>
    <v-btn icon slot="activator" @click="assign()">
      <v-icon color="blue darken-4">assignment</v-icon>
    </v-btn>
    <span>{{title}}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    title: String
  },
  methods: {
    assign() {
      this.$emit("assign");
    }
  }
};
</script>

<style>
</style>
